
import Vue from 'vue';
import { TranslateResult } from 'vue-i18n/types';
import MISC_DATA from '@/store/modules/MiscDataModule';
import UTILS from '@/store/modules/UtilityModule';

export default Vue.extend({
	name: 'Calculator',

	mixins: [],

	data() {
		return {
			truck_sizes: ['L', 'XL', 'XXL'],
			input_index: {
				months: 5,
				insurance: 1,
				size: 0
			}
		};
	},

	computed: {
		UTILS: () => UTILS,
		MISC_DATA: () => MISC_DATA,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},

		calcSectionHeight(): number {
			return 700;
		},

		packages(): TranslateResult {
			return this.$t('long_rent.calc_section.packages');
		},

		prices(): any {
			return this.MISC_DATA?.basedata?.ltr;
			// return {
			// 	leasing: [370000, 390000, 410000],
			// 	panel: [350000, 370000, 390000],
			// 	price: {
			// 		l: {
			// 			pack1: [
			// 				360000, 360000, 360000, 363000, 363000, 363000, 366000, 366000, 366000, 369000,
			// 				369000, 369000,
			// 			],
			// 			pack2: [
			// 				370000, 370000, 370000, 370000, 370000, 370000, 370000, 370000, 370000, 370000,
			// 				370000, 370000,
			// 			],
			// 			pack3: [
			// 				380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000,
			// 				380000, 380000,
			// 			],
			// 		},
			// 		xl: {
			// 			pack1: [
			// 				370000, 370000, 370000, 370000, 370000, 370000, 370000, 370000, 370000, 370000,
			// 				370000, 370000,
			// 			],
			// 			pack2: [
			// 				380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000,
			// 				380000, 380000,
			// 			],
			// 			pack3: [
			// 				390000, 390000, 390000, 390000, 390000, 390000, 390000, 390000, 390000, 390000,
			// 				390000, 390000,
			// 			],
			// 		},
			// 		xxl: {
			// 			pack1: [
			// 				380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000, 380000,
			// 				380000, 380000,
			// 			],
			// 			pack2: [
			// 				390000, 390000, 390000, 390000, 390000, 390000, 390000, 390000, 390000, 390000,
			// 				390000, 390000,
			// 			],
			// 			pack3: [
			// 				400000, 400000, 400000, 400000, 400000, 400000, 400000, 400000, 400000, 400000,
			// 				400000, 400000,
			// 			],
			// 		},
			// 	},
			// };
		},

		leasingPrice(): number {
			if (typeof this.input_index.size === 'number') {
				return this.prices.leasing[this.input_index.size];
			}
			return 0;
		},

		aboPrice(): any {
			const size = ['l', 'xl', 'xxl'][this.input_index.size];

			const pack_idx = ['pack1', 'pack2', 'pack3'][this.input_index.insurance];

			const prices_array = this.prices.price[size][pack_idx];

			return prices_array[this.input_index.months];
		},

		percentDiff(): number {
			return this.aboPrice / this.leasingPrice;
		}
	}
});
